import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Alert, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PageHeader from '../components/common/PageHeader';
import StudentForm from '../components/students/StudentForm';
import { createStudent } from '../services/studentService';

const CreateStudentPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (formData) => {
    setLoading(true);
    setError(null);

    try {
      const response = await createStudent(formData);
      const created = response.data?.data?.student;
      const studentId = created?._id || created?.id;

      if (studentId) {
        navigate(`/students/${studentId}`);
      } else {
        navigate('/students');
      }
    } catch (err) {
      const message =
        err.response?.data?.message || err.message || 'Failed to create student';
      setError(message);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <PageHeader
        title="Add New Student"
        breadcrumbs={[
          { label: 'Dashboard', link: '/dashboard' },
          { label: 'Students', link: '/students' },
          { label: 'Add New Student' },
        ]}
      >
        <IconButton onClick={() => navigate('/students')} size="large">
          <ArrowBackIcon />
        </IconButton>
      </PageHeader>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <StudentForm onSubmit={handleSubmit} loading={loading} />
    </Box>
  );
};

export default CreateStudentPage;
